import {Chips} from "../chips"
import {Image} from "../image"
import {ImageChips} from "../ImageChips"
import {StripBanner} from "../stripBanner"
import {Heading} from "../heading"
import {Copy} from "../copy"

/* istanbul ignore next */
const component = {
    chips: Chips,
    "copy-text": Copy,
    image: Image,
    "side-image": Image,
    "image-chips": ImageChips,
    roundels: ImageChips,
    strip: StripBanner,
    heading: Heading,
}

export type ComponentKey = keyof typeof component

export const getSearchBannerComponent = (name: ComponentKey) => {
    if (component[name] == null) return null
    return component[name]
}
